import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z","key":"svg-0"}]]

const IconLetterDSmall = createReactComponent('outline', 'letter-d-small', 'LetterDSmall', __iconNode);

export default IconLetterDSmall;